import { addFormFields, removeFieldsById } from "../../../../../utils/FormFields/RemoveFields/handleRemoveFields";
import { HideShowNotificationPeriodFieldsConfig } from "./addHideShowFileds";

const handleFieldChange = (dataFieldName, updateFormData, basicInformationFormData) => {
    switch (dataFieldName) {
        case "isApproval": {
            const { isApproval } = updateFormData;
            if (isApproval === "yes") {
                /**
               * @param {object} basicInformationFormData - The form data object.
               * @param {Array<object>} HideShowSupportFileFieldConfig - Fields to add for file uploads.
               * @param {string} "relevantDiplomasCertificatesFile" - The ID after which the fields will be added.
               */
                addFormFields(basicInformationFormData, HideShowNotificationPeriodFieldsConfig, "isApproval");
            } else {
                /**
                 * @param {object} basicInformationFormData - The form data object.
                 * @param {Array<string>} ['notificationPeriod'] - The IDs of fields to remove.
                 */
                removeFieldsById(basicInformationFormData, ['notificationPeriod']);
            }
            break;
        }
        default:
            break;
    }
};

export default handleFieldChange;


